import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = ["onClick", "title"]
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_16 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_20 = { class: "fw-bold" }
const _hoisted_21 = { class: "fw-bold" }
const _hoisted_22 = { class: "mt-15 mt-md-0" }
const _hoisted_23 = { class: "pagination mb-0" }
const _hoisted_24 = {
  key: 0,
  class: "page-item"
}
const _hoisted_25 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 1,
  class: "page-item"
}
const _hoisted_28 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog modal-sm modal-dialog-centered" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = { class: "modal-header" }
const _hoisted_32 = { class: "modal-title fs-5" }
const _hoisted_33 = { class: "modal-body" }
const _hoisted_34 = { style: {} }
const _hoisted_35 = {
  key: 0,
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_38 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_39 = { class: "modal-footer" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_42 = { style: {"color":"#FFF"} }
const _hoisted_43 = {
  class: "modal fade",
  id: "viewValueModal",
  tabindex: "-1",
  "aria-labelledby": "viewValueModalLabel",
  "aria-hidden": "true"
}
const _hoisted_44 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_45 = { class: "modal-content" }
const _hoisted_46 = { class: "modal-header" }
const _hoisted_47 = {
  class: "modal-title fs-5",
  id: "viewValueModalLabel"
}
const _hoisted_48 = { class: "modal-body" }
const _hoisted_49 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_50 = { class: "row form-control shadow-none d-flex flex-row align-items-start mx-0 py-10" }
const _hoisted_51 = { class: "col-auto ps-0 pt-2" }
const _hoisted_52 = ["title"]
const _hoisted_53 = { class: "modal-footer" }
const _hoisted_54 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_55 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "modal-header" }
const _hoisted_58 = { class: "modal-title fs-5" }
const _hoisted_59 = { class: "modal-body" }
const _hoisted_60 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_61 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_62 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_63 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_64 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_65 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-md-6" }
const _hoisted_68 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_69 = ["placeholder"]
const _hoisted_70 = { class: "invalid-feedback" }
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_73 = ["placeholder"]
const _hoisted_74 = { class: "invalid-feedback" }
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_77 = ["placeholder"]
const _hoisted_78 = { class: "invalid-feedback" }
const _hoisted_79 = { class: "col-md-6" }
const _hoisted_80 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_81 = ["selected"]
const _hoisted_82 = ["selected"]
const _hoisted_83 = ["selected"]
const _hoisted_84 = ["selected"]
const _hoisted_85 = ["selected"]
const _hoisted_86 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_87 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_88 = { value: "" }
const _hoisted_89 = ["value", "selected"]
const _hoisted_90 = { class: "modal-footer" }
const _hoisted_91 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}
const _hoisted_92 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_93 = {
  class: "modal fade",
  id: "bulkConfigModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_94 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_95 = { class: "modal-content" }
const _hoisted_96 = { class: "modal-header" }
const _hoisted_97 = { class: "modal-title fs-5" }
const _hoisted_98 = { class: "modal-body" }
const _hoisted_99 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_100 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_101 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_102 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_103 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_104 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = { class: "col-md-6" }
const _hoisted_107 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_108 = ["placeholder"]
const _hoisted_109 = { class: "invalid-feedback" }
const _hoisted_110 = { class: "col-md-6" }
const _hoisted_111 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_112 = ["placeholder"]
const _hoisted_113 = { class: "invalid-feedback" }
const _hoisted_114 = { class: "col-md-6" }
const _hoisted_115 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_116 = ["placeholder"]
const _hoisted_117 = { class: "invalid-feedback" }
const _hoisted_118 = { class: "col-md-6" }
const _hoisted_119 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_120 = ["selected"]
const _hoisted_121 = ["selected"]
const _hoisted_122 = ["selected"]
const _hoisted_123 = ["selected"]
const _hoisted_124 = ["selected"]
const _hoisted_125 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_126 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_127 = { value: "" }
const _hoisted_128 = ["value", "selected"]
const _hoisted_129 = {
  key: 2,
  class: "mt-20"
}
const _hoisted_130 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_131 = { class: "table-responsive" }
const _hoisted_132 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_133 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_134 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_135 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_136 = { style: {"max-width":"220px","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_137 = { class: "text-end pe-0" }
const _hoisted_138 = ["onClick", "title"]
const _hoisted_139 = { class: "modal-footer d-flex justify-content-between align-items-center" }
const _hoisted_140 = ["disabled"]
const _hoisted_141 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}

import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import router from '../../router/index'
import * as yup from 'yup';
import { Configuration, ConfigurationByCategory, Provider } from "@/utils/Model";
import { useI18n } from "vue-i18n";
import { current_permissions } from '../../utils/permission';
import { showToast, checkSessionValidate } from "@/utils/function";

const itemsPerPage = 10;

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigSetting',
  setup(__props) {

const backApi = inject('back');
const btnLoad = ref(true);
const { t } = useI18n();
const selectedValidation = ref('N');
const selected = ref(false);

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

const allConfigurations = ref(new Array<ConfigurationByCategory & { code?: string | null }>());

const searchQuery = ref('');

let edit = 0;
let itemCode = '';
let selectedOrganization = '';
const providers = ref(new Array<Provider>());

const selectedProvider = ref(null);

const selectedValueKey = ref('');
const selectedValueToShow = ref('');

const showValue = (key: string, valeur: any) => {
  selectedValueKey.value = key;
  selectedValueToShow.value = valeur !== null && valeur !== undefined ? String(valeur) : '';
}

const copyValueToClipboard = () => {
  const el = document.getElementById('viewValueInput') as HTMLTextAreaElement | null;
  if (!el) return;
  el.select();
  el.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(el.value);
  showToast("Copié", "green");
}

let data = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'key': '', 'description': '', val: '', category: '' };
const pageLoad = ref(false);

const formValues = reactive({
  key: "",
  val: "",
  description: "",
  category: ""
});

const schema = yup.object({
  key: yup.string().required('Le nom est requis'),
  description: yup.string().required('La description est requise'),
  val: yup.string().required('La description est requise'),
});

function handleValidationChange(event) {
  selectedValidation.value = event.target.value;
}

function handleProviderChange(event) {
  selectedProvider.value = event.target.value;
}

const initField = () => {
  formValues.key = '';
  formValues.val = '';
  formValues.description = '';
  formValues.category = '';
  edit = 0;
}

let showSelectProvider = ref(false)
const selectedCategorie = ref('');
function handleCategorieChange(event) {
  selectedCategorie.value = event.target.value;

  if (selectedCategorie.value == 'PROVIDER') {
    showSelectProvider.value = true
  } else {
    selectedProvider.value = null
    showSelectProvider.value = false
  }
}

const formValuesBulk = reactive({
  key: "",
  val: "",
  description: ""
});

const errorsBisBulk = reactive({ 'key': '', 'description': '', val: '' });

const selectedCategorieBulk = ref('');
const selectedProviderBulk = ref(null);
const showSelectProviderBulk = ref(false);

const bulkBtnLoad = ref(true);
const bulkErrors = ref('');
const bulkErrorId = ref('');
const bulkSuccess = ref('');

// liste des configurations en attente d'envoi, affichée sous le formulaire
const pendingConfigs = ref(new Array<{ key: string; value: string; description: string; category: string; status: string }>());

// réinitialise tout l'état du modal d'ajout en masse à l'ouverture
const initBulkField = () => {
  formValuesBulk.key = '';
  formValuesBulk.val = '';
  formValuesBulk.description = '';
  errorsBisBulk.key = '';
  errorsBisBulk.description = '';
  errorsBisBulk.val = '';
  selectedCategorieBulk.value = '';
  selectedProviderBulk.value = null;
  showSelectProviderBulk.value = false;
  pendingConfigs.value = [];
  bulkErrors.value = '';
  bulkErrorId.value = '';
  bulkSuccess.value = '';
}

function handleCategorieChangeBulk(event) {
  selectedCategorieBulk.value = event.target.value;

  if (selectedCategorieBulk.value == 'PROVIDER') {
    showSelectProviderBulk.value = true
  } else {
    selectedProviderBulk.value = null
    showSelectProviderBulk.value = false
  }
}

function handleProviderChangeBulk(event) {
  selectedProviderBulk.value = event.target.value;
}

function validateBulkField(field) {
  schema
    .validateAt(field, { key: formValuesBulk.key, val: formValuesBulk.val, description: formValuesBulk.description })
    .then(() => {
      errorsBisBulk[field] = "";
    })
    .catch(err => {
      errorsBisBulk[field] = err.message;
    });
  bulkErrors.value = ''
}

const addToPendingList = () => {
  try {
    schema.validateSync(
      { key: formValuesBulk.key, val: formValuesBulk.val, description: formValuesBulk.description },
      { abortEarly: false }
    );
  } catch (error: any) {
    errorsBisBulk.key = '';
    errorsBisBulk.description = '';
    errorsBisBulk.val = '';
    if (error.inner && error.inner.length) {
      error.inner.forEach((e: any) => {
        errorsBisBulk[e.path] = e.message;
      });
    }
    return;
  }

  if (!selectedCategorieBulk.value) {
    showToast("Veuillez sélectionner une catégorie", "red");
    return;
  }

  // Nouveau contrôle : entreprise obligatoire si catégorie = PROVIDER
  if (selectedCategorieBulk.value === 'PROVIDER' && !selectedProviderBulk.value) {
    showToast("Veuillez sélectionner une entreprise (provider)", "red");
    return;
  }

  pendingConfigs.value.push({
    key: formValuesBulk.key,
    value: formValuesBulk.val,
    description: formValuesBulk.description,
    category: selectedCategorieBulk.value,
    status: 'ACTIVE'
  });

  formValuesBulk.key = '';
  formValuesBulk.val = '';
  formValuesBulk.description = '';
  errorsBisBulk.key = '';
  errorsBisBulk.description = '';
  errorsBisBulk.val = '';
}
const removeFromPendingList = (index: number) => {
  pendingConfigs.value.splice(index, 1);
}

const submitBulk = () => {
  if (pendingConfigs.value.length === 0) {
    showToast("Ajoutez au moins une configuration à la liste", "red");
    return;
  }

  bulkBtnLoad.value = false;
  bulkErrors.value = '';
  bulkErrorId.value = '';

  axios.post(`${backApi}/secure/configs/all`, {
    provider: selectedProviderBulk.value,
    organization: null,
    configs: pendingConfigs.value
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then((response) => {
    bulkBtnLoad.value = true;
    showToast("Enregistrement effectué avec succès", "green");
    setTimeout(() => {
      router.go();
    }, 500);
  }).catch((error) => {
    bulkBtnLoad.value = true;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        bulkErrorId.value = error.response.data.errorId;
        bulkErrors.value = error.response.data.message;
      }
      showToast(error.response.data.message, "red");
    }
  });
}

function flattenConfiguration(obj: any, path: string[] = []): Array<any> {
  const result: any[] = [];

  Object.entries(obj || {}).forEach(([key, value]) => {
    const isLeafWithCode =
      value !== null &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      'code' in (value as any) &&
      'value' in (value as any);

    const isPlainObjectToRecurse =
      value !== null &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      !isLeafWithCode;

    if (isPlainObjectToRecurse) {
      result.push(...flattenConfiguration(value, [...path, key]));
    } else if (isLeafWithCode) {
      const v: any = value;
      result.push({
        code: v.code ?? null,
        key: key,
        valeur: v.value,
        type: path.join(" >> ")
      });
    } else {
      result.push({
        code: null,
        key: key,
        valeur: value,
        type: path.join(" >> ")
      });
    }
  });

  return result;
}

const filteredConfigurations = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allConfigurations.value;

  return allConfigurations.value.filter((c) => {
    const key = (c.key ?? '').toString().toLowerCase();
    const type = (c.type ?? '').toString().toLowerCase();
    const valeur = (c.valeur ?? '').toString().toLowerCase();
    return key.includes(q) || type.includes(q) || valeur.includes(q);
  });
});

const page = ref(1);
const total = computed(() => filteredConfigurations.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(total.value / itemsPerPage)));
const paginatedConfigurations = computed(() => {
  const start = (page.value - 1) * itemsPerPage;
  return filteredConfigurations.value.slice(start, start + itemsPerPage);
});
const setPage = (numPage: number) => {
  page.value = numPage;
};

watch(searchQuery, () => {
  page.value = 1;
});

const getConfigurations = () => {
  axios.get(backApi + '/secure/configs/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      data = response.data;
      allConfigurations.value = flattenConfiguration(response.data);
      page.value = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const showConfiguration = (code) => {
  if (!code) {
    showToast("Impossible d'identifier cet élément de configuration (aucun code disponible)", "red");
    return;
  }
  axios.get(backApi + '/secure/configs/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.key = response.data.key;
      formValues.val = response.data.value;
      formValues.description = response.data.description;
      formValues.category = response.data.category;
      selectedCategorie.value = response.data.category;
      itemCode = response.data.code;
      edit = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          console.log(error.response);
        }
      }
    });
}

// Récupère une page de providers depuis l'API (forme { data, pagination })
const fetchProvidersPage = (targetPage: number) => {
  const url = `${backApi}/secure/providers/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

// Charge TOUTES les pages de providers (boucle sur pagination.numPages)
const getProviders = async () => {
  try {
    const first = await fetchProvidersPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchProvidersPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    providers.value = collected;
    data = collected;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const showScreen = (code) => {
  if (!code) {
    showToast("Impossible d'identifier cet élément de configuration (aucun code disponible)", "red");
    return;
  }
  itemCode = code;
}

const cancel = () => {
  itemCode = "";
  errorId.value = "";
  errors.value = "";
}

const save = () => {
  if (edit == 0) {
    storeConfiguration()
  } else {
    updateConfiguration()
  }
}

const storeConfiguration = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);

    axios.post(`${backApi}/secure/configs/new`, {
      provider: selectedProvider.value,
      organization: null,
      key: formValues.key,
      value: formValues.val,
      description: formValues.description,
      category: selectedCategorie.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      showToast("Enregistrement effectué avec succès", "green");
      setTimeout(() => {
        router.go();
      }, 500);
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
        showToast(error.response.data.message, "red");
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const updateConfiguration = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/configs/${itemCode}/edit`, {
      key: formValues.key,
      value: formValues.val,
      description: formValues.description,
      category: selectedCategorie.value,
      code: itemCode,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        router.go();
      }
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const deleteConfiguration = () => {
  btnLoad.value = false;
  try {
    const headers = {
      'Authorization': `Bearer ${token}`
    }
    const data = {
      code: itemCode
    }
    axios.delete(`${backApi}/secure/configs/delete`, { headers, data })
      .then(response => {
        btnLoad.value = true;
        if (response.status === 200) {
          router.go();
        }
      })
      .catch(error => {
        btnLoad.value = true;
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
      });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const exportExcel = () => {
  import("../../utils/Export2Excel").then((excel) => {
    const Header = ["CODE RECHARGEMENT", "DESCRIPTION", "MONTANT", "DATE", "STATUT"];
    const Fields = ["code", "description", "amount", "createdAt", "status"];
    const dataForExcel = formatJSon(Fields, data);
    excel.export_json_to_excel({
      header: Header,
      data: dataForExcel,
      sheetName: "Feuil1",
      filename: "rechargement",
      autoWidth: true,
      bookType: "xlsx",
    });
  });
}

function formatJSon(FilterData, JsonData) {
  return JsonData.map((v) => FilterData.map(j => {
    return v[j];
  }));
}

onMounted(async () => {
  checkSessionValidate(1);
  await getProviders();
  getConfigurations();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[19] || (_cache[19] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: "Rechercher..."
              }, null, 512), [
                [_vModelText, searchQuery.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_unref(current_permissions)('create_config'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#bulkConfigModal",
                    onClick: initBulkField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('configurations.addBulkConfig') || 'Ajout en masse') + " ", 1),
                    _cache[20] || (_cache[20] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              (_unref(current_permissions)('create_config'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('configurations.addConfig')) + " ", 1),
                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('configurations.config')), 1),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('configurations.category')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('configurations.value')), 1),
                    _cache[22] || (_cache[22] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedConfigurations.value, (configuration, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: configuration.code ?? (configuration.key + '-' + configuration.type + '-' + idx)
                    }, [
                      _createElementVNode("td", null, _toDisplayString(configuration.key), 1),
                      _createElementVNode("td", null, _toDisplayString(configuration.type), 1),
                      _createElementVNode("td", null, [
                        (configuration.valeur !== null)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-none border-0 p-0",
                              type: "button",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#viewValueModal",
                              onClick: ($event: any) => (showValue(configuration.key, configuration.valeur)),
                              title: _ctx.$t('configurations.viewValue') || 'Voir la valeur'
                            }, [...(_cache[23] || (_cache[23] = [
                              _createElementVNode("i", { class: "flaticon-eye" }, null, -1)
                            ]))], 8, _hoisted_12))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          disabled: "",
                          style: {"opacity":"0.35","cursor":"not-allowed"},
                          title: _ctx.$t('configurations.comingSoon') || 'Bientôt disponible'
                        }, [...(_cache[24] || (_cache[24] = [
                          _createElementVNode("i", { class: "flaticon-dots" }, null, -1)
                        ]))], 8, _hoisted_14)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (total.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (total.value>itemsPerPage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_ctx.$t('configurations.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(Math.min(page.value*itemsPerPage, total.value)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('configurations.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(total.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('configurations.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (total.value<=itemsPerPage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                        _createTextVNode(_toDisplayString(_ctx.$t('configurations.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(total.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('configurations.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(total.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('configurations.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_22, [
                    _createElementVNode("ul", _hoisted_23, [
                      ((page.value-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (setPage(page.value-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[25] || (_cache[25] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==page.value)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_25, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (setPage(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_26))
                        ]))
                      }), 128)),
                      ((page.value+1)<=numPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (setPage(page.value+1))),
                              "aria-label": "Next"
                            }, [...(_cache[26] || (_cache[26] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("h1", _hoisted_32, _toDisplayString(_ctx.$t('configurations.alert')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel()))
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              (errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_35, _toDisplayString(_ctx.$t('configurations.confirmDelete')), 1))
                : _createCommentVNode("", true)
            ]),
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("h6", _hoisted_37, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_38, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              type: "button",
              class: "btn default-outline-btn bg-transparent",
              style: {"background-color":"#FFF"},
              "data-bs-dismiss": "modal",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (cancel()))
            }, _toDisplayString(_ctx.$t('configurations.no')), 1),
            _createElementVNode("button", {
              disabled: !btnLoad.value,
              type: "button",
              class: "btn",
              style: {"background-color":"#EB9355"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (deleteConfiguration()))
            }, [
              (!btnLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_41))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('configurations.yes')), 1)
            ], 8, _hoisted_40)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("h1", _hoisted_47, _toDisplayString(selectedValueKey.value), 1),
            _cache[27] || (_cache[27] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('configurations.value')), 1),
            _createElementVNode("div", _hoisted_50, [
              _withDirectives(_createElementVNode("textarea", {
                class: "col fw-medium text-black fs-md-14 border-0",
                id: "viewValueInput",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedValueToShow).value = $event)),
                readonly: "",
                rows: "4",
                style: {"resize":"vertical","background":"transparent","overflow-y":"auto","max-height":"260px","word-break":"break-all","font-family":"'Courier New', monospace"}
              }, null, 512), [
                [_vModelText, selectedValueToShow.value]
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("a", {
                  href: "#",
                  class: "text-decoration-none d-block text-center",
                  onClick: _withModifiers(copyValueToClipboard, ["prevent"]),
                  title: _ctx.$t('configurations.copy') || 'Copier'
                }, [...(_cache[28] || (_cache[28] = [
                  _createElementVNode("i", {
                    class: "flaticon-draft fs-6",
                    style: {"color":"#000"}
                  }, null, -1)
                ]))], 8, _hoisted_52)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("button", {
              type: "button",
              class: "btn text-white",
              style: {"background-color":"#EB9355"},
              onClick: copyValueToClipboard
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("i", {
                class: "flaticon-draft fs-6 me-5",
                style: {"color":"#FFF"}
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('configurations.copy') || 'Copier'), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("h1", _hoisted_58, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('configurations.addConfig') : _ctx.$t('configurations.editConfig')), 1),
              _cache[30] || (_cache[30] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_59, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("h6", _hoisted_61, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_62, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("h6", _hoisted_64, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t('configurations.configName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['key'] }]),
                        placeholder: _ctx.$t('configurations.configNamePlaceholder'),
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formValues.key) = $event)),
                        id: "key",
                        onBlur: _cache[8] || (_cache[8] = ($event: any) => (validate('key')))
                      }, null, 42, _hoisted_69), [
                        [_vModelText, formValues.key]
                      ]),
                      _createElementVNode("span", _hoisted_70, _toDisplayString(errorsBis['key']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('configurations.value')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['val'] }]),
                        placeholder: _ctx.$t('configurations.valuePlaceholder'),
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formValues.val) = $event)),
                        id: "val",
                        onBlur: _cache[10] || (_cache[10] = ($event: any) => (validate('val')))
                      }, null, 42, _hoisted_73), [
                        [_vModelText, formValues.val]
                      ]),
                      _createElementVNode("span", _hoisted_74, _toDisplayString(errorsBis['val']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.$t('configurations.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        placeholder: _ctx.$t('configurations.descriptionPlaceholder'),
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formValues.description) = $event)),
                        id: "description",
                        onBlur: _cache[12] || (_cache[12] = ($event: any) => (validate('description')))
                      }, null, 42, _hoisted_77), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_78, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t('configurations.category')), 1),
                    _createElementVNode("select", {
                      name: "mode",
                      id: "mode",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleCategorieChange,
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        value: "",
                        selected: selectedCategorie.value==''
                      }, _toDisplayString(_ctx.$t('configurations.select')), 9, _hoisted_81),
                      _createElementVNode("option", {
                        value: "PROVIDER",
                        selected: selectedCategorie.value=='PROVIDER'
                      }, "PROVIDER", 8, _hoisted_82),
                      _createElementVNode("option", {
                        value: "SYMFONY",
                        selected: selectedCategorie.value=='SYMFONY'
                      }, "SYMFONY", 8, _hoisted_83),
                      _createElementVNode("option", {
                        value: "APP",
                        selected: selectedCategorie.value=='APP'
                      }, "APP", 8, _hoisted_84),
                      _createElementVNode("option", {
                        value: "BROKER",
                        selected: selectedCategorie.value=='BROKER'
                      }, "BROKER", 8, _hoisted_85)
                    ], 32)
                  ]),
                  (_unref(showSelectProvider))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                        _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('configurations.provider')), 1),
                        _createElementVNode("select", {
                          name: "provider",
                          id: "provider",
                          class: "form-select fs-md-15 text-black shadow-none",
                          onChange: handleProviderChange,
                          required: ""
                        }, [
                          _createElementVNode("option", _hoisted_88, _toDisplayString(_ctx.$t('configurations.select')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providers.value, (provider) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: provider.code,
                              key: provider.code,
                              selected: selectedProvider.value==provider.code
                            }, _toDisplayString(provider.name), 9, _hoisted_89))
                          }), 128))
                        ], 32)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_90, [
              (_unref(current_permissions)('create_config', 'edit_config'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_91, [
                    (!btnLoad.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_92))
                      : _createCommentVNode("", true),
                    _cache[31] || (_cache[31] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(edit) == 0 ? _ctx.$t('configurations.save') : _ctx.$t('configurations.edit')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_93, [
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitBulk, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("h1", _hoisted_97, _toDisplayString(_ctx.$t('configurations.addBulkConfig') || 'Ajout en masse'), 1),
              _cache[32] || (_cache[32] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_98, [
              (bulkErrors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                    _createElementVNode("h6", _hoisted_100, _toDisplayString(bulkErrorId.value), 1),
                    _createElementVNode("h6", _hoisted_101, _toDisplayString(bulkErrors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (bulkSuccess.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    _createElementVNode("h6", _hoisted_103, _toDisplayString(bulkSuccess.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t('configurations.configName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBisBulk['key'] }]),
                        placeholder: _ctx.$t('configurations.configNamePlaceholder'),
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formValuesBulk.key) = $event)),
                        id: "keyBulk",
                        onBlur: _cache[14] || (_cache[14] = ($event: any) => (validateBulkField('key')))
                      }, null, 42, _hoisted_108), [
                        [_vModelText, formValuesBulk.key]
                      ]),
                      _createElementVNode("span", _hoisted_109, _toDisplayString(errorsBisBulk['key']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.$t('configurations.value')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBisBulk['val'] }]),
                        placeholder: _ctx.$t('configurations.valuePlaceholder'),
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formValuesBulk.val) = $event)),
                        id: "valBulk",
                        onBlur: _cache[16] || (_cache[16] = ($event: any) => (validateBulkField('val')))
                      }, null, 42, _hoisted_112), [
                        [_vModelText, formValuesBulk.val]
                      ]),
                      _createElementVNode("span", _hoisted_113, _toDisplayString(errorsBisBulk['val']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('configurations.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBisBulk['description'] }]),
                        placeholder: _ctx.$t('configurations.descriptionPlaceholder'),
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formValuesBulk.description) = $event)),
                        id: "descriptionBulk",
                        onBlur: _cache[18] || (_cache[18] = ($event: any) => (validateBulkField('description')))
                      }, null, 42, _hoisted_116), [
                        [_vModelText, formValuesBulk.description]
                      ]),
                      _createElementVNode("span", _hoisted_117, _toDisplayString(errorsBisBulk['description']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t('configurations.category')), 1),
                    _createElementVNode("select", {
                      name: "modeBulk",
                      id: "modeBulk",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleCategorieChangeBulk,
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        value: "",
                        selected: selectedCategorieBulk.value==''
                      }, _toDisplayString(_ctx.$t('configurations.select')), 9, _hoisted_120),
                      _createElementVNode("option", {
                        value: "PROVIDER",
                        selected: selectedCategorieBulk.value=='PROVIDER'
                      }, "PROVIDER", 8, _hoisted_121),
                      _createElementVNode("option", {
                        value: "SYMFONY",
                        selected: selectedCategorieBulk.value=='SYMFONY'
                      }, "SYMFONY", 8, _hoisted_122),
                      _createElementVNode("option", {
                        value: "APP",
                        selected: selectedCategorieBulk.value=='APP'
                      }, "APP", 8, _hoisted_123),
                      _createElementVNode("option", {
                        value: "BROKER",
                        selected: selectedCategorieBulk.value=='BROKER'
                      }, "BROKER", 8, _hoisted_124)
                    ], 32)
                  ]),
                  (showSelectProviderBulk.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                        _createElementVNode("label", _hoisted_126, _toDisplayString(_ctx.$t('configurations.provider')), 1),
                        _createElementVNode("select", {
                          name: "providerBulk",
                          id: "providerBulk",
                          class: "form-select fs-md-15 text-black shadow-none",
                          onChange: handleProviderChangeBulk,
                          required: ""
                        }, [
                          _createElementVNode("option", _hoisted_127, _toDisplayString(_ctx.$t('configurations.select')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providers.value, (provider) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: provider.code,
                              key: provider.code,
                              selected: selectedProviderBulk.value==provider.code
                            }, _toDisplayString(provider.name), 9, _hoisted_128))
                          }), 128))
                        ], 32)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (pendingConfigs.value.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                    _createElementVNode("label", _hoisted_130, _toDisplayString(_ctx.$t('configurations.pendingList') || 'Configurations à créer') + " (" + _toDisplayString(pendingConfigs.value.length) + ") ", 1),
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("table", _hoisted_132, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_133, _toDisplayString(_ctx.$t('configurations.config')), 1),
                            _createElementVNode("th", _hoisted_134, _toDisplayString(_ctx.$t('configurations.category')), 1),
                            _createElementVNode("th", _hoisted_135, _toDisplayString(_ctx.$t('configurations.value')), 1),
                            _cache[33] || (_cache[33] = _createElementVNode("th", {
                              scope: "col",
                              class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                            }, null, -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingConfigs.value, (item, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                              _createElementVNode("td", null, _toDisplayString(item.key), 1),
                              _createElementVNode("td", null, _toDisplayString(item.category), 1),
                              _createElementVNode("td", _hoisted_136, _toDisplayString(item.value), 1),
                              _createElementVNode("td", _hoisted_137, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (removeFromPendingList(i)),
                                  title: _ctx.$t('configurations.remove') || 'Retirer'
                                }, [...(_cache[34] || (_cache[34] = [
                                  _createElementVNode("i", {
                                    class: "flaticon-delete",
                                    style: {"color":"red"}
                                  }, null, -1)
                                ]))], 8, _hoisted_138)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_139, [
              _createElementVNode("button", {
                type: "button",
                class: "btn text-white",
                style: {"background-color":"#336e92"},
                onClick: addToPendingList
              }, [
                _cache[35] || (_cache[35] = _createElementVNode("i", {
                  class: "flaticon-plus position-relative me-5 fs-12",
                  style: {"color":"#FFF"}
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('configurations.addToList') || 'Ajouter à la liste'), 1)
              ]),
              (_unref(current_permissions)('create_config'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "submit",
                    class: "btn text-white",
                    style: {"background-color":"#EB9355"},
                    disabled: !bulkBtnLoad.value || pendingConfigs.value.length===0
                  }, [
                    (!bulkBtnLoad.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_141))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('configurations.save')) + " (" + _toDisplayString(pendingConfigs.value.length) + ") ", 1)
                  ], 8, _hoisted_140))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[36] || (_cache[36] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})